/**
 * Top view of a plane, nose along +x, centred on the origin, about 28 units nose to tail.
 *
 * In `lib/` because two screens draw it — the flight card's route illustration and the
 * flight map — and a feature may not import from another feature. One drawing, so the
 * aircraft a reader learns on the card is the one they find on the map.
 */
export const PLANE_PATH =
  'M14 0 C14 -1.2 12.6 -2 10.4 -2 L3.2 -2 L-4.6 -13 L-6.8 -13 L-2.6 -2 L-9.2 -1.7 ' +
  'L-11.8 -5.8 L-13.6 -5.8 L-12.6 -1.1 L-14 -0.5 L-14 0.5 L-12.6 1.1 L-13.6 5.8 ' +
  'L-11.8 5.8 L-9.2 1.7 L-2.6 2 L-6.8 13 L-4.6 13 L3.2 2 L10.4 2 C12.6 2 14 1.2 14 0 Z';
